import { ReactNode } from "react";

interface StatusCardProps {
  icon: ReactNode;
  title: string;
  description: ReactNode;
  action?: ReactNode;
}

export function StatusCard({ icon, title, description, action }: StatusCardProps) {
  return (
    <div className="flex h-full min-w-0 flex-1 flex-col items-center px-6 pt-[20vh]">
      <div className="flex min-w-0 flex-col items-center justify-center gap-6 rounded-lg p-6 text-center text-balance md:p-12">
        <div className="flex max-w-sm flex-col items-center gap-2 text-center">
          <div className="bg-muted text-foreground mb-2 flex size-10 shrink-0 items-center justify-center rounded-lg [&_svg]:size-6">
            {icon}
          </div>
          <div className="text-lg font-medium tracking-tight">{title}</div>
          <div className="text-muted-foreground text-sm/relaxed">{description}</div>
        </div>
        {action && <div className="flex w-full max-w-sm min-w-0 flex-col items-center gap-4 text-sm">{action}</div>}
      </div>
    </div>
  );
}
